const ErrorWrapper = ({ error }) => {
    return (
        <>
            {error&&<div class="scale-up-hor-left text-sm text-red-700 rounded-lg dark:bg-gray-800 dark:text-red-400" role="alert">
                <span class="font-medium"> {error}</span>
            </div>}
        </>
    );
}

export default ErrorWrapper;